import { useResponsive } from '@/contexts/ResponsiveContext';
import { useShowIncidences } from '@/modules/auditorAudits/hooks/useShowIncidences';
import classNames from 'classnames';
import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FlagFillIcon from 'remixicon-react/FlagFillIcon';
import FlagLineIcon from 'remixicon-react/FlagLineIcon';
import styles from './index.less';

const details = {
  [true]: [FlagFillIcon, 'audits.hideAllIncidences'],
  [false]: [FlagLineIcon, 'audits.showAllIncidences']
};

const ShowIncidencesAction = () => {
  const { t } = useTranslation('auditorAudits');
  const { showAllIncidences, setShowAllIncidences } = useShowIncidences();
  const { isTablet } = useResponsive();

  const onClickShowIncidences = useCallback(() => {
    setShowAllIncidences(prev => !prev);
  }, [setShowAllIncidences]);

  const [FlagIcon, title] = useMemo(() => (
    details?.[showAllIncidences]
  ), [showAllIncidences]);

  return (<>
    <div className={ classNames(styles.bookMarkBar, isTablet && 'hidden') } onClick={ onClickShowIncidences }>
      <span className="bookmark-navigation-text">{ t(title) }</span>
      <FlagIcon style={ { transform: 'rotate(180deg)', margin: '10px 0 0 0', padding: '2px' } } />
    </div>
  </>);
};

export default memo(ShowIncidencesAction);
